import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as h } from "../../../../IconBase-CxZyIWw2.js";
const r = i((l, o) => /* @__PURE__ */ c.jsx(
  h,
  {
    ref: o,
    ...l,
    image: (s) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        fill: "none",
        viewBox: "0 0 303 64",
        ...s,
        children: [
          /* @__PURE__ */ c.jsx("circle", { cx: 32, cy: 32, r: 32, fill: "#6F5CFF" }),
          /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "#fff",
              d: "m25.868 13.461-.192-.384c2.785-1.104 5.186-1.44 7.779-1.44 7.682 0 15.413 4.225 15.509 10.323.047 3.36-2.161 5.762-5.378 5.81-9.363.144-7.203-14.549-16.277-14.405-.433 0-1.153.048-1.441.096m18.918 31.642c-4.37.096-14.26-2.88-20.022-18.822-2.017-5.57-3.41-6.866-5.522-6.818-3.217.096-6.29 6.386-6.146 13.06.288 10.036 8.643 19.303 20.455 19.11 9.267-.144 13.78-5.665 14.74-6.914l-.192-.24c-.48.288-1.536.576-3.313.624"
            }
          ),
          /* @__PURE__ */ c.jsx("g", { clipPath: "url(#clip0_2263_59381)", children: /* @__PURE__ */ c.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M104.534 45.797c4.131 0 7.76-2 9.674-4.71h.005l4.902 4.306c-3.151 4.303-8.211 7.505-14.581 7.505-10.436 0-19.608-7.528-19.608-19.423C84.926 21.579 94.414 14 104.427 14c6.403 0 11.379 2.998 14.576 7.625l-5.269 4.628c-2.077-3.189-4.962-5.25-9.302-5.25-5.59 0-11.97 4.001-11.97 12.476 0 7.95 6.064 12.318 12.072 12.318M210.547 14h-7.012v38.11h7.012zm-41.122 19.16a10.5 10.5 0 0 0-2.109-.209c-3.583 0-6.691 1.736-6.691 7.315V52.11h-7.012V26.212h5.655l.799 4.173c1.45-3.43 5.506-4.382 7.723-4.382.581 0 1.106.051 1.635.107zm16.378 13.37c-3.424 0-6.826-2.525-6.826-7.37s3.402-7.37 6.826-7.37c3.425 0 6.826 2.473 6.826 7.37 0 4.896-3.401 7.37-6.826 7.37m0-21.108c-7.746 0-13.833 5.736-13.833 13.738s6.087 13.738 13.833 13.738 13.837-5.793 13.837-13.738c0-7.946-6.087-13.738-13.837-13.738m36.01 13.738c0 4.845 3.401 7.37 6.825 7.37s6.826-2.474 6.826-7.37c0-4.897-3.401-7.37-6.826-7.37s-6.825 2.524-6.825 7.37m-7.007 0c0-8.002 6.087-13.738 13.832-13.738 7.751 0 13.838 5.792 13.838 13.738s-6.092 13.738-13.838 13.738-13.832-5.737-13.832-13.738m-74.83 10.16c-1.422 2.423-4.428 3.476-7.165 3.476-6.273 0-9.855-4.58-9.855-10.21V26.21h7.007v14.95c0 2.896 1.477 5.212 4.744 5.212s4.902-2.107 4.902-5.106V26.211h7.007V52.11h-6.129zm129.877-13.154c0 3.314-1.728 6.104-4.149 8.002h-.009c2.63 2.079 4.572 5.059 4.572 8.87 0 6.353-5.102 10.966-11.849 10.966-4.665 0-8.712-2.38-10.566-6.219l-.148-.31 5.589-2.73.144.33c1.013 2.348 3.369 3.179 5.079 3.179 3.025 0 5.576-2.381 5.576-5.421 0-3.342-2.398-5.672-5.576-5.672-2.161 0-4.135 1.193-5.032 3.04l-.149.311-5.455-2.673.158-.311c.711-1.41 1.854-2.52 3.123-3.351-2.245-1.545-4.103-4.678-4.103-8.006 0-6.4 4.944-10.745 11.398-10.745 1.705 0 3.317.335 4.767.957l3.48-3.477 3.843 3.839-2.988 2.984c1.441 1.884 2.295 3.657 2.295 6.437m-6.337.08c0-2.98-2.152-5.11-5.079-5.11-2.853 0-5.06 2.162-5.06 5.11 0 2.946 2.105 5.114 5.06 5.114s5.079-2.135 5.079-5.115m21.002 11.928-10.69-21.963h7.853l6.593 14.48 6.686-14.48h7.486l-18.498 37.446h-7.43l7.486-14.467z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_2263_59381", children: /* @__PURE__ */ c.jsx("path", { fill: "#fff", d: "M84 14h218.447v50H84z" }) }) })
        ]
      }
    )
  }
));
r.displayName = "CurologyLogoLockupIcon";
export {
  r as CurologyLogoLockupIcon,
  r as default
};
//# sourceMappingURL=index.js.map
